import React from 'react';
import { MenuItem } from '../../components/Menu';
import newTabIcon from '../../icons/editor/newTab.svg';

interface OpenInNewTabMenuItemProps {
  link: string;
  onCloseToolbar: () => void;
}

const OpenInNewTabMenuItem = ({
  link,
  onCloseToolbar,
}: OpenInNewTabMenuItemProps) => {
  return (
    <MenuItem
      icon={newTabIcon}
      to={link}
      target="_blank"
      onClick={onCloseToolbar}
    >
      Open in new tab
    </MenuItem>
  );
};

export default OpenInNewTabMenuItem;
